class WaypointFlavorBundle extends HTMLElement {
  connectedCallback() {
    for (const form of this.querySelectorAll('[data-bundle-form]')) {
      form.addEventListener('submit', () => this.publishSelection(form));
      form.addEventListener('change', () => this.updatePrice(form));
      this.updatePrice(form);
    }
  }

  updatePrice(form) {
    const total = [...form.querySelectorAll('select')].reduce((sum, select) => {
      return sum + Number(select.selectedOptions[0]?.dataset.price || 0);
    }, 0);
    const price = form.querySelector('[data-bundle-price]');
    if (!price || !total) return;
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(total / 100);
  }

  publishSelection(form) {
    const variantIds = [...form.querySelectorAll('select[name$="[id]"]')].map(
      (select) => select.value,
    );
    const detail = {
      productId: this.dataset.productId,
      bundleSize: Number(form.dataset.bundleSize),
      variantIds,
      value: [...form.querySelectorAll('select')].reduce((sum, select) => {
        return sum + Number(select.selectedOptions[0]?.dataset.price || 0);
      }, 0) / 100,
      currency: window.Shopify?.currency?.active || 'USD',
    };
    document.dispatchEvent(new CustomEvent('waypoint:bundle-add', { detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'waypoint_bundle_add', ...detail });
    }
    this.publishShopifyEvent('waypoint:bundle_add', detail);
  }

  publishShopifyEvent(eventName, detail) {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    const result = publish.call(window.Shopify.analytics, eventName, detail);
    result?.catch?.((error) => {
      console.warn(`Unable to publish ${eventName}`, error);
    });
  }
}

if (!customElements.get('waypoint-flavor-bundle')) {
  customElements.define('waypoint-flavor-bundle', WaypointFlavorBundle);
}
